/* eslint-disable indent */
import React, {useCallback, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {MainLoader, DataGrid, ConfirmationModalPromise} from '@components';
import {GreenButton, StyledH3, WhiteButton} from '@styled';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import styled from 'styled-components';
import moment from 'moment';
import {sagaActions} from './redux/saga';

const StyledHeadRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .heading {
  }
  .actions {
  }
`;

const RowActions = ({data, onAction}) => {
  return (
    <div>
      <WhiteButton
        onClick={() => onAction('edit', data)}
        style={{margin: '.16em'}}
      >
        <i className="fa fa-edit mr-1" />
        Edit
      </WhiteButton>
      <WhiteButton
        onClick={() => onAction('delete', data)}
        style={{margin: '.16em'}}
      >
        <i className="fa fa-trash mr-1" />
        Delete
      </WhiteButton>
    </div>
  );
};

const ManageInvites = () => {
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const remoteData = useSelector((state) => state.invites.invites);
  const isLoading = useSelector((state) => state.invites.invites.loading);
  const [editRow, setEditRow] = useState(null);
  const [showAddEditModal, setShowAddEditModal] = useState(false);

  const history = useHistory();

  const [pagination, setPagination] = React.useState({
    page: 1,
    pageSize: 20,
    totalCount: 0,
    sortOn: 'sentOn',
    sortDir: 'DESC',
  });

  useEffect(() => {
    if (
      remoteData.page !== pagination.page ||
      remoteData.pageSize !== pagination.pageSize ||
      remoteData.totalCount !== pagination.totalCount ||
      remoteData.sortOn !== pagination.sortOn ||
      remoteData.sortDir !== pagination.sortDir
    ) {
      setPagination({
        page: remoteData.page,
        pageSize: remoteData.pageSize,
        totalCount: remoteData.totalCount,
        sortOn: remoteData.sortOn,
        sortDir: remoteData.sortDir,
      });
    }
  }, [remoteData]);

  const fetchData = ({
    page = 1,
    pageSize = pagination.pageSize,
    sortOn,
    sortDir,
  }) => {
    dispatch({
      type: sagaActions.FETCH_INVITES,
      payload: {
        values: {
          page,
          pageSize,
          sortOn,
          sortDir,
        },
      },
    });
  };

  const handleDeleteInvite = () => {
    //   remove
  };

  const handleRowAction = useCallback(
    (action, row) => {
      switch (action) {
        case 'edit': {
          setEditRow(row);
          setShowAddEditModal(true);
          break;
        }
        case 'delete': {
          ConfirmationModalPromise({
            title: `Are you sure you want to delete this [${row.id}] invite?`,
            show: true,
            confirmBtn: 'Yes',
            cancelBtn: 'No',
            headTitle: 'Confirmation!',
          }).then(
            () => {
              handleDeleteInvite(row);
            },
            () => {
              //  do nothing on failure
            }
          );
          break;
        }
        default:
          break;
      }
    },
    [editRow, showAddEditModal]
  );

  const handleAddInvite = () => {
    history.push('/corporates/send-invite');
  };

  const renderRowActions = (colProps) => {
    return <RowActions data={colProps} onAction={handleRowAction} />;
  };

  const Columns = React.useMemo(
    () => [
      {
        accessor: 'id',
        Header: 'Invite ID',
        className: 'grey-column d-none d-lg-block',
        width: 50,
        tooltip: false,
      },
      {
        accessor: 'corporateName',
        Header: 'Corporate',
        tooltip: false,
        className: 'd-none d-lg-block',
      },
      {
        accessor: 'sentTo',
        Header: 'Sent To',
        tooltip: false,
        className: 'd-none d-lg-block',
      },
      {
        accessor: 'sentOn',
        Header: 'Sent On',
        tooltip: false,
        className: 'd-none d-lg-block',
        Cell: ({value}) => (value ? moment(value).fromNow() : ''),
      },
      {
        accessor: 'isUsed',
        Header: 'Status',
        tooltip: false,
        className: 'd-none d-lg-block',
        Cell: ({value}) => (value ? 'Accepted' : 'Invitation Sent'),
      },
      {
        id: 'actions',
        Header: <div className="d-none d-lg-block">Actions</div>,
        accessor: renderRowActions,
        disableSortBy: true,
        disableFilters: true,
        width: 50,
      },
    ],
    [pagination]
  );

  return (
    <>
      {isLoading && (
        <MainLoader
          minHeight="100vh"
          spinnerColor="#479541"
          background="rgba(0,0,0,0.2)"
        />
      )}
      <div>
        <StyledHeadRow>
          <StyledH3>{t('owner.invites.pageHeading')}</StyledH3>
          <div className="actions">
            <GreenButton className="ml-1" onClick={handleAddInvite}>
              <i className="fa fa-plus mr-1" />
              {t('owner.invites.addInvite')}
            </GreenButton>
          </div>
        </StyledHeadRow>
        <DataGrid
          columns={Columns}
          data={remoteData.data}
          onFetchData={fetchData}
          pagination={pagination}
          filtering={false}
          expandEnabled={false}
        />
      </div>
    </>
  );
};

export default ManageInvites;
